import styled, { css } from 'styled-components';

export const Container = styled.div`
   position: fixed;
   display: flex;
   width: 100%;
   height: 100%;
   top: 0px;
   left: 0px;
   z-index: 9999;
   background-color: rgba(0, 0, 0, 0.57);
   user-select: none;
   animation: fadeIn 0.2s ease-in-out;
   @keyframes fadeIn {
      from {
         opacity: 0;
      }
      to {
         opacity: 1;
      }
   };
`
export const Content = styled.div`
   display: flex;
   width: 100%;
   height:100%;
   flex-direction: column;
   border-radius: 10px;
   background: #ffffff;
   object-fit: contain;
`;
export const Controls = styled.div`
   display: flex;
   width: 100%;
   height: 3.5rem;
   padding: 0.5rem;
   align-items: center;
   justify-content: end;
   border-bottom: 1px solid rgb(222, 226, 230);
   background-color: #f6f6f6;
   > div:nth-child(1){
      display: flex;
      gap: 0.5rem;
      > span {
         display: flex;
         justify-content: center;
         align-items: center;
         font-size: 1.75rem;
         padding: 0.2rem 0.5rem ;
         border-radius: 6px;
         cursor: pointer;
         &:hover{
            background-color: #e5e2e2;
         }
      }
      > span:nth-last-child(1){
         margin-left: 4rem;
         font-size: 2.5rem;
         &:hover{
            background-color: transparent;
            color: red;
         }
      }
   };
`;
export const Wrapper = styled.div`
   display: flex;
   width: 100%;
   height: 100%;
   justify-content: center;
   align-items: center;
   overflow: hidden;
   object-fit: contain;
   > div {
      ${({ rotate }) => rotate &&
      css`
            transform: rotate(${rotate}deg);
         `
   };
   }
   > div > div {
      cursor:grab;
      justify-content: center;
   }
   img{
      width: 100%;
      height: 100%;
      max-height: 600px;
   }
`;